import React from 'react';
import get from 'lodash/get';
import { graphql, useFragment } from 'react-relay';
import { Inline } from '@atlaskit/primitives/compiled';
import { projectTypeLabels } from '@atlassian/jira-projects-directory-v3-common/src/project-types/index.tsx';
import { useIntl } from '@atlassian/jira-intl';
import type { ProjectTypeCell$key } from '@atlassian/jira-relay/src/__generated__/ProjectTypeCell.graphql';

type Props = {
	project: ProjectTypeCell$key;
};

export const ProjectTypeCell = ({ project }: Props): React.JSX.Element => {
	const { formatMessage } = useIntl();

	const { projectType, projectStyle } = useFragment(
		graphql`
			fragment ProjectTypeCell on JiraProject {
				projectStyle
				projectType
			}
		`,
		project,
	);

	const projectStyleKey = projectStyle || 'TEAM_MANAGED_PROJECT';
	const label = get(projectTypeLabels, [projectStyleKey, projectType || '']);

	const finalLabel = label ? formatMessage(label) : projectType;
	return <Inline>{finalLabel}</Inline>;
};
